import { Box, Card, List, ListItem, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { JunoUser } from '@juno/client-api/model';
import { useDirectoryData } from '../Contexts/DirectoryContext';
import { SAVED_PAGE_SIZE, useDirectoryFilters } from '../Contexts/DirectoryFiltersContext';
import { ReportsPagination } from '../ModerationAdmin/styles';
import DirectoryTile from './DirectoryTile';

export interface ExtendedUser extends JunoUser {
  saved_users: string[];
}

interface Props {
  setNewMeetingOpen: (value: boolean) => void;
  startChat: (user: JunoUser) => void;
  setSelectedUser: (user: JunoUser | null) => void;
  messengerDisabled: boolean;
}

export const SavedUsers = ({
  setNewMeetingOpen,
  startChat,
  setSelectedUser,
  messengerDisabled,
}: Props) => {
  const {
    settings: { site },
    handleSaveUser,
    filteredSavedUsersQuery,
    filteredSavedUsersCountQuery,
    allSavedUsersCountQuery,
  } = useDirectoryData();
  const { data: savedUsers } = filteredSavedUsersQuery;
  const { data: filteredSavedUsersCount } = filteredSavedUsersCountQuery;
  const { data: allSavedUsersCount } = allSavedUsersCountQuery;
  const { savedUsersPage, setSavedUsersPage } = useDirectoryFilters();

  const navigate = useNavigate();

  if (!savedUsers) return null;

  const count = Math.ceil((filteredSavedUsersCount?.count || 1) / SAVED_PAGE_SIZE);

  return (
    <Card sx={{ p: 0, bgcolor: 'transparent', mb: 3 }}>
      <Stack direction='row' alignItems={'center'}>
        <Typography variant='h6'>Saved Contacts</Typography>{' '}
        <Typography variant='caption' sx={{ ml: 2 }}>
          {filteredSavedUsersCount?.count} of {allSavedUsersCount?.count} Directory Results
        </Typography>
      </Stack>

      {savedUsers.length > 0 && (
        <>
          <List>
            {savedUsers.map((user) => (
              <ListItem key={`saved_users_${user.id}`} sx={{ pl: 0, pr: 0, pb: 0, mb: 0.5 }}>
                <DirectoryTile
                  user={user as JunoUser}
                  selectUser={(user) => navigate(`/${site?.slug}/user/${user.id}`)}
                  startMeeting={(user) => {
                    setSelectedUser(user);
                    setNewMeetingOpen(true);
                  }}
                  startChat={(user) => startChat(user)}
                  saveUser={(user) => handleSaveUser(user)}
                  isSaved={true}
                  messengerDisabled={messengerDisabled}
                />
              </ListItem>
            ))}
          </List>
          {filteredSavedUsersCount && filteredSavedUsersCount.count > SAVED_PAGE_SIZE && (
            <Box display={'flex'} justifyContent={'center'}>
              <ReportsPagination
                count={count}
                page={savedUsersPage}
                size='small'
                onChange={(_, value) => setSavedUsersPage(value)}
              />
            </Box>
          )}
        </>
      )}
    </Card>
  );
};
